import { ProductDetailsTab, ProductDetailsTabLink, ProductDetailsTabLinksNav } from './components';

export const ProductDetailsTabs = {
  LinksNav: ProductDetailsTabLinksNav,
  Link: ProductDetailsTabLink,
  Tab: ProductDetailsTab,
};
